<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1230 1230">
    <MapLayer :shop-map-ids="shopMapIds" />
    <WardNameLayer />
    <g id="saitama-clickable-group" data-name="clickable_map">
      <template v-for="item in this.mapItems">
        <polygon
          :key="item.id"
          :id="`saitama-${item.name_en}`"
          tabindex="0"
          role="radio"
          :aria-label="item.name"
          :aria-checked="isChecked(item.id)"
          :points="item.points"
          class="map-selector"
          @click="selectArea(item.id)"
        />
      </template>
    </g>
    <MarkLayer />
  </svg>
</template>

<script>
import MapLayer from './MapLayer.vue';
import MarkLayer from './MarkLayer.vue';
import WardNameLayer from './WardNameLayer.vue';

export default {
  components: {
    MapLayer,
    MarkLayer,
    WardNameLayer,
  },
  props: ['mapAreaId', 'shopMapIds'],
  data: () => ({
    selectedArea: '',
  }),
  computed: {
    mapItems() {
      return [
        {
          id: 34,
          name: this.$t('saitama_nishi_ku'),
          name_en: 'nishi-ku',
          points: '153 817.5 11 369 306.5 337.727 378 817.5 153 817.5',
        },
        {
          id: 35,
          name: this.$t('saitama_kita_ku'),
          name_en: 'kita-ku',
          points:
            '306.5 337.727 280 118 457 76 623 391.5 320.997 435 306.5 337.727',
        },
        {
          id: 36,
          name: this.$t('saitama_omiya_ku'),
          name_en: 'omiya-ku',
          points:
            '320.997 435 352.516 646.5 681.976 646.5 623 391.5 320.997 435',
        },
        {
          id: 37,
          name: this.$t('saitama_minuma_ku'),
          name_en: 'minuma-ku',
          points:
            '523.955 203.254 792.162 101.834 1006.5 646.5 681.976 646.5 623 391.5 523.955 203.254',
        },
        {
          id: 38,
          name: this.$t('saitama_chuo_ku'),
          name_en: 'chuo-ku',
          points:
            '352.516 646.5 378 817.5 608 1007.255 628 646.5 352.516 646.5',
        },
        {
          id: 39,
          name: this.$t('saitama_sakura_ku'),
          name_en: 'sakura-ku',
          points: '409.5 1194 153 817.5 378 817.5 608 1007.255 409.5 1194',
        },
        {
          id: 40,
          name: this.$t('saitama_urawa_ku'),
          name_en: 'urawa-ku',
          points: '628 646.5 878 646.5 874.456 1007.255 608 1007.255 628 646.5',
        },
        {
          id: 41,
          name: this.$t('saitama_minami_ku'),
          name_en: 'minami-ku',
          points:
            '409.5 1194 608 1007.255 1010 1007.255 871.5 1201.5 409.5 1194',
        },
        {
          id: 42,
          name: this.$t('saitama_midori_ku'),
          name_en: 'midori-ku',
          points:
            '874.456 1007.255 878 646.5 1216.5 646.5 1216.5 1007.255 874.456 1007.255',
        },
        {
          id: 43,
          name: this.$t('saitama_iwatsuki_ku'),
          name_en: 'iwatsuki-ku',
          points: '763.5 29 1006.5 646.5 1216.5 646.5 1212 38 763.5 29',
        },
      ];
    },
  },
  mounted: function() {
    this.selectedArea = this.mapAreaId;
  },
  methods: {
    selectArea(value) {
      if (this.shopMapIds && !this.shopMapIds.includes(value)) return;
      this.selectedArea = value;
      this.$emit('input', value);
      this.$emit('changeMapArea');
    },
    isChecked(value) {
      return this.selectedArea === value;
    },
  },
};
</script>

<style scoped>
.map-selector {
  fill: transparent;
  stroke: transparent;
  stroke-linejoin: round;
  stroke-width: 8px;
}
.map-selector:focus {
  outline: none;
}
.map-selector[aria-checked='true'] {
  stroke: #B22C27;
  stroke-width: 16px;
}
</style>
